export let AsyncStatusType;
(function (AsyncStatusType) {
  AsyncStatusType["FAILED"] = "FAILED";
  AsyncStatusType["STARTED"] = "STARTED";
  AsyncStatusType["SUCCEEDED"] = "SUCCEEDED";
  AsyncStatusType["UNINITIALIZED"] = "UNINITIALIZED";
})(AsyncStatusType || (AsyncStatusType = {}));